import { IonContent, IonHeader, IonPage } from "@ionic/react";
import Header from "../components/layout/Header";
import { Helmet } from "react-helmet-async";
const LoonMail = () => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        {/* <IonHeader mode="ios">
          <Header />
        </IonHeader> */}
        <IonContent>
          <div
            style={{
              width: "100%",
              height: "calc(100vh - 135px)",
              position: "relative",
            }}
          >
            <iframe
              src={`https://email.loonlog.ca`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              title="Email"
            />
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default LoonMail;
